export let payBasisTypes = [
    {
        name: 'hr',
        longName: 'hour',
    },
    {
        name: 'yr',
        longName: 'year',
    },
]

export let jobTypes = [
    {
        name: 'Full Time',
        abbr: 'FT',
        wkHours: 40,
    },
    {
        name: 'Part Time',
        abbr: 'PT',
        wkHours: 20,
    },
    {
        name: 'Contract',
        abbr: 'CT',
        wkHours: '',
    },
]

export let remoteStatuses = [
    {   
        name: 'Remote',
    },
    {
        name: 'Hybrid',
    },
    {
        name: 'On Site',
    },
]

export let seniorityTypes = [
    {
        name: 'Entry Level',
    },
    {
        name: 'Mid Level',
    },
    {
        name: 'Senior',
    },
    {
        name: 'Team Lead',
    },
    {
        name: 'Management',
    },
]

export let educationLevels = [
    {
        name: 'None Listed',
        abbr: 'N/A',
    },
    {
        name: 'High School',
        abbr: 'HS',
    },
    {
        name: 'Associates',
        abbr: 'AA',
    },
    {
        name: 'Bachelors',
        abbr: 'BS',
    },
    {
        name: 'Masters',
        abbr: 'MS',
    },
]
export let sourceSites = [
    {
        name: 'LinkedIn',
    },
    {
        name: 'Indeed',
    },
    {
        name: 'ZipRecruiter',
    },
    {
        name: 'Google',
    },
]
